// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"cc63ffe4","258":"e91b83c0","461":"9aaa4b34","685":"29562ba4"}[chunkId] + ".chunk.css";
};